<template>
  <div class="separate" :style="{ ...props.style }"></div>
</template>

<script lang="ts" setup>
const props = defineProps({
  style: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  }
})
</script>

<style scoped lang="less">
.separate {
  background: transparent;
  width: 100%;
}
</style>
